import React from 'react';
import { Navigate } from 'react-router-dom';
import LoadingBubbleOrganisms from '../components/organisms/LoadingBubbleOrganisms';
import MenuBarsTemplate from '../components/templates/MenuBarsTemplate';
import { useAuth } from '../controllers/services/useAuth';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { useGetAuth } = useAuth();
  const { isLoading, data } = useGetAuth();

  if (isLoading) {
    return (
      <MenuBarsTemplate title="">
        <LoadingBubbleOrganisms />
      </MenuBarsTemplate>
    );
  }

  if (data === undefined || !Object.keys(data).length) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

export default PrivateRoute;